<form class="form-material m-t-10 row" [formGroup]="questionRadiogroupCheckboxesForm">
  <div class="form-group col-12 answer-even-input">
    <input
      *ngFor="let item of titlePropertiesArray; let i = index"
      [placeholder]="titlePlaceholderArray[i]"
      [formControlName]="item"
      class="form-control m-b-10"
      [tooltip]="popTemplate"
      [isOpen]="canShowFormControlError(item)"
      container="body"
      #pop="bs-tooltip"
      triggers=""
      placement="bottom"
      containerClass="error-tooltip"
      [id]="item"
      type="text"
    />
  </div>
  <div
    [class.satisfaction-rate]="getIsSatisfactionRate()"
    class="form-group col-12 row"
    *ngFor="let item of choicesPropertiesArray; let i = index"
  >
    <i [ngClass]="getIsCheckbox() ? 'ti-layout-width-full' : 'fa fa-circle-thin'" class="p-t-10"></i>
    <div class="col-7 answer-even-input">
      <div *ngFor="let langItem of item; let i = index">
        <input
          *ngIf="getIsRadiobuttonValue(langItem)"
          [placeholder]="choicesPlaceholderArray[i]"
          [formControlName]="langItem"
          class="form-control"
          [tooltip]="popTemplate"
          [isOpen]="canShowFormControlError(langItem)"
          container="body"
          #pop="bs-tooltip"
          triggers=""
          placement="bottom"
          containerClass="error-tooltip"
          [id]="langItem"
          type="text"
        />
      </div>
    </div>
    <div *ngIf="getIsRating()" class="col-2 p-r-20" style="height: 85px">
      <input
        [formControlName]="ratesPropertiesArray[i][0]"
        tooltip="Requires 1 or more digits"
        [isOpen]="canShowFormControlError(ratesPropertiesArray[i][0])"
        placement="bottom"
        containerClass="error-tooltip"
        #pop="bs-tooltip"
        class="form-control"
        [id]="ratesPropertiesArray[i][0]"
        type="number"
      />
    </div>
    <div *ngIf="getIsSatisfactionRate()" class="select-satisfaction-rate p-r-20">
      <ngx-select
        [allowClear]="true"
        [items]="answerCategoryTypes"
        [formControlName]="srPropertiesArray[i][0]"
        [id]="srPropertiesArray[i][0]"
        placeholder="Select satisfaction rate"
      >
      </ngx-select>
    </div>
    <div lass="btn btn-sm m-t-5" (click)="deleteInputGroup(item)">
      <i class="float-right btn btn-sm ti-close"></i>
    </div>
  </div>
</form>

<ng-template #popTemplate>This field is required and must be longer then 1 letter</ng-template>
